/**
 * Module de simulation de notifications pour Master League
 * Ce script permet aux administrateurs de simuler des notifications pour l'utilisateur boynino
 */

// Définir le composant Alpine pour la modal de simulation
window.notificationSimulatorData = function() {
    return {
        showModal: false,
        notificationType: 'info',
        notificationMessage: '',
        notificationLink: '',
        isSubmitting: false,
        successMessage: '',
        errorMessage: '',

        // Réinitialiser les messages
        resetMessages() {
            this.successMessage = '';
            this.errorMessage = '';
        },

        // Ouvrir la modal
        openModal() {
            this.showModal = true;
            this.resetMessages();
        },

        // Fermer la modal
        closeModal() {
            this.showModal = false;
            this.resetForm();
        },

        // Réinitialiser le formulaire
        resetForm() {
            this.notificationType = 'info';
            this.notificationMessage = '';
            this.notificationLink = '';
            this.isSubmitting = false;
            this.resetMessages();
        },

        // Envoyer la notification
        submitNotification() {
            // Vérifier que le message n'est pas vide
            if (!this.notificationMessage.trim()) {
                this.errorMessage = 'Le message ne peut pas être vide.';
                return;
            }

            this.isSubmitting = true;
            this.resetMessages();

            // Préparer les données à envoyer
            const data = {
                type: this.notificationType,
                message: this.notificationMessage,
                link: this.notificationLink
            };

            // Envoyer la requête à l'API
            fetch('/admin/simulate-notification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(data => {
                            throw new Error(data.error || 'Une erreur est survenue');
                        });
                    }
                    return response.json();
                })
                .then(data => {
                    this.successMessage = data.message;
                    this.notificationMessage = '';
                    this.notificationLink = '';

                    // Fermer la modal après 2 secondes
                    setTimeout(() => {
                        this.closeModal();
                    }, 2000);
                })
                .catch(error => {
                    this.errorMessage = error.message;
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        }
    };
};
